import { useState, useCallback } from 'react';
import { BusinessStats, UseBusinessStatsReturn } from '../types/business';

interface UseBusinessStatsOptions {
  businessId?: string;
}

export function useBusinessStats({ businessId }: UseBusinessStatsOptions = {}): UseBusinessStatsReturn {
  const [stats, setStats] = useState<BusinessStats | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchStats = useCallback(async () => {
    if (!businessId) {
      console.log('No business ID available for fetching stats');
      return;
    }

    setIsLoading(true);
    setError(null);
    
    try {
      const response = await fetch(`/api/business/${businessId}/stats`, {
        method: 'GET',
        credentials: 'same-origin'
      });
      
      const data = await response.json();
      
      if (response.ok && data.success) {
        setStats(data.stats);
      } else {
        setError(data.error || 'Failed to fetch business statistics');
        setStats(null);
      }
    } catch (error) {
      console.error('Error fetching business stats:', error);
      setError(error instanceof Error ? error.message : 'An unexpected error occurred');
      setStats(null);
    } finally {
      setIsLoading(false);
    }
  }, [businessId]);

  const refreshStats = useCallback(async () => {
    await fetchStats();
  }, [fetchStats]);

  return {
    stats,
    isLoading,
    error,
    fetchStats,
    refreshStats
  };
}